import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "@/components/common/Logo";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";

export default function AuthLayout({ title, subtitle, children, footer }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2 auth-bg relative">
      {/* Floating language switcher (top-right) */}
      <div className="absolute top-5 right-5 z-20">
        <LanguageSwitcher />
      </div>

      {/* Left: form */}
      <div className="flex items-center justify-center p-8 lg:p-12">
        <div className="w-full max-w-md">
          <Link
            to="/"
            className="inline-flex items-center mb-12 group"
            data-testid="brand-link"
          >
            <Logo variant="full" size="lg" className="group-hover:opacity-80 transition-opacity" />
          </Link>

          <div className="mb-8">
            <h1
              className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]"
              data-testid="auth-title"
            >
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 text-[#475569]" data-testid="auth-subtitle">
                {subtitle}
              </p>
            )}
          </div>

          {children}

          {footer && (
            <div className="mt-8 text-sm text-[#475569]" data-testid="auth-footer">
              {footer}
            </div>
          )}
        </div>
      </div>

      {/* Right: marketing aside */}
      <div className="hidden lg:flex relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1400&q=80"
            alt="hospitality"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#0F172A]/90 via-[#102A43]/70 to-[#0F766E]/30" />
        </div>

        <div className="relative z-10 flex flex-col justify-end p-12 text-white max-w-2xl">
          <div className="label-eyebrow text-white/70">{t("auth.hero_eyebrow")}</div>
          <h2 className="font-heading text-4xl xl:text-5xl font-bold tracking-tight leading-tight mt-4">
            {t("auth.hero_title")}
          </h2>
          <p className="mt-5 text-white/80 text-lg leading-relaxed">
            {t("auth.hero_subtitle")}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-white/15 pt-6">
            <div>
              <div className="font-heading text-3xl font-black">€497</div>
              <div className="label-eyebrow text-white/60 mt-1">
                {t("auth.hero_kpi_mrr")}
              </div>
            </div>
            <div>
              <div className="font-heading text-3xl font-black">3</div>
              <div className="label-eyebrow text-white/60 mt-1">
                {t("auth.hero_kpi_tenants")}
              </div>
            </div>
            <div>
              <div className="font-heading text-3xl font-black">22</div>
              <div className="label-eyebrow text-white/60 mt-1">
                {t("auth.hero_kpi_modules")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
